export default __webpack_public_path__ + "static/media/10.7.7a4692e2.jpg";